import React from "react";
import { useTranslation } from "react-i18next";

export default function TermsConditions() {
  const { t } = useTranslation();
  const effectiveDate = new Date().toLocaleString("en-US", {
    month: "long",
    year: "numeric",
  });
  return (
    <div className="container-fluid maxContainerSection mainHeaderPadding ">
      <div className="row alignCenterSection">
        <div className="col-md-10">
          <div className="commonPadding pb-0">
            <div className="policyHeaderSection">
              <h1 className="m-0 h1Class">
                {t("SMSHub_angola")} <br />
                {t("terms_conditions_use")}
              </h1>
              <p className="m-0 peraClass">
                {t("last_updated")} {effectiveDate}
              </p>
            </div>

            <div>
              <div className="policyContentSection">
                <p className="m-0">{t("welcome_to_SMSHub")}</p>
                <p className="m-0">{t("welcome_to_SMSHub_desc")}</p>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">1. {t("acceptance_of_terms")}</h3>
                <p className="m-0">{t("acceptance_of_terms_desc")}</p>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">2. {t("changes_to_terms")}</h3>
                <p className="m-0">{t("changes_to_terms_desc")}</p>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">3. {t("the_SMSHub_service")}</h3>
                <p className="m-0">{t("the_SMSHub_service_desc")}</p>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">
                  4. {t("Account_registration_and_security")}
                </h3>
                <ul>
                  <li>{t("Account_security_first")}</li>
                  <li>{t("Account_security_second")}</li>
                  <li>{t("Account_security_third")}</li>
                </ul>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">
                  5. {t("Acceptable_use_service")}
                </h3>
                <p className="m-0">{t("Acceptable_use_service_desc")}</p>
                <ul>
                  <li>{t("Acceptable_use_service_liFirst")}</li>
                  <li>{t("Acceptable_use_service_liSecond")}</li>
                  <li>En{t("Acceptable_use_service_lithird")}</li>
                  <li>{t("Acceptable_use_service_lifour")}</li>
                  <li>{t("Acceptable_use_service_lifive")}</li>
                </ul>
                <p className="m-0">{t("Acceptable_use_service_descsec")}</p>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">6. {t("pricing_and_payments")}</h3>
                <ul>
                  <li>{t("pricing_and_payments_lifirst")}</li>
                  <li>{t("pricing_and_payments_lisecond")}</li>
                  <li>{t("pricing_and_payments_lithird")}</li>
                </ul>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">7. {t("intellectual_property")}</h3>
                <p className="m-0">{t("intellectual_property_desc")}</p>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">8. {t("limitation_liability")}</h3>
                <p className="m-0">{t("limitation_liability_desc")}</p>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">9. {t("indemnification")}</h3>
                <p className="m-0">{t("indemnification_desc")}</p>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">
                  10. {t("governing_law_jurisdiction")}
                </h3>
                <p className="m-0">{t("governing_law_jurisdiction_desc")}</p>
              </div>

              <div className="policyContentSection">
                <h3 className="m-0 h3Class">11. {t("contact_us")}</h3>
                <p className="m-0">{t("contact_us_desc_new")}</p>
                <ul>
                  <li> geral@g-corporate.com</li>
                  <li> +244 935 516 476.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
